/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  LogoutCommand,
  NotFoundErrorResult,
  PasswordProtectionQuery,
  Result,
  ResultOfAccessResponseViewModel,
  ResultOfActingAsResponseViewModel,
  ResultOfBoolean,
  ResultOfListOfIntermediaryAssociatesViewModel,
  ValidationErrorResult,
  WebSealUserInfoResponseViewModel,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    LogoutCommandFromJSON,
    LogoutCommandToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    PasswordProtectionQueryFromJSON,
    PasswordProtectionQueryToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfAccessResponseViewModelFromJSON,
    ResultOfAccessResponseViewModelToJSON,
    ResultOfActingAsResponseViewModelFromJSON,
    ResultOfActingAsResponseViewModelToJSON,
    ResultOfBooleanFromJSON,
    ResultOfBooleanToJSON,
    ResultOfListOfIntermediaryAssociatesViewModelFromJSON,
    ResultOfListOfIntermediaryAssociatesViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
    WebSealUserInfoResponseViewModelFromJSON,
    WebSealUserInfoResponseViewModelToJSON,
} from '../models';

export interface SecurityActingAsRequest {
    intermediaryCode?: string | null;
}

export interface SecurityGetAccessRequest {
    intermediaryCode?: string | null;
}

export interface SecurityGetIntermediaryAssociatesInformationRequest {
    intermediaryCode: string;
}

export interface SecurityLogoutRequest {
    request: LogoutCommand;
}

export interface SecurityUnlockSiteRequest {
    query: PasswordProtectionQuery;
}

/**
 * 
 */
export class SecurityApi extends runtime.BaseAPI {

    /**
     * Get Acting as permission for the authenticated user Viewd on the intermediary code passed in
     */
    async securityActingAsRaw(requestParameters: SecurityActingAsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfActingAsResponseViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.intermediaryCode !== undefined) {
            queryParameters['intermediaryCode'] = requestParameters.intermediaryCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/securities/acting-as`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfActingAsResponseViewModelFromJSON(jsonValue));
    }

    /**
     * Get Acting as permission for the authenticated user Viewd on the intermediary code passed in
     */
    async securityActingAs(requestParameters: SecurityActingAsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfActingAsResponseViewModel> {
        const response = await this.securityActingAsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the access information for the authenticated user
     */
    async securityGetAccessRaw(requestParameters: SecurityGetAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfAccessResponseViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.intermediaryCode !== undefined) {
            queryParameters['intermediaryCode'] = requestParameters.intermediaryCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/securities/access`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfAccessResponseViewModelFromJSON(jsonValue));
    }

    /**
     * Get the access information for the authenticated user
     */
    async securityGetAccess(requestParameters: SecurityGetAccessRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfAccessResponseViewModel> {
        const response = await this.securityGetAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get intermediary associates
     */
    async securityGetIntermediaryAssociatesInformationRaw(requestParameters: SecurityGetIntermediaryAssociatesInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfIntermediaryAssociatesViewModel>> {
        if (requestParameters.intermediaryCode === null || requestParameters.intermediaryCode === undefined) {
            throw new runtime.RequiredError('intermediaryCode','Required parameter requestParameters.intermediaryCode was null or undefined when calling securityGetIntermediaryAssociatesInformation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/securities/sanpay/associates/{intermediaryCode}`.replace(`{${"intermediaryCode"}}`, encodeURIComponent(String(requestParameters.intermediaryCode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfIntermediaryAssociatesViewModelFromJSON(jsonValue));
    }

    /**
     * Get intermediary associates
     */
    async securityGetIntermediaryAssociatesInformation(requestParameters: SecurityGetIntermediaryAssociatesInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfIntermediaryAssociatesViewModel> {
        const response = await this.securityGetIntermediaryAssociatesInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A drop in replacement for the Gateway user-info endpoint. This is why it does not return a Result object
     */
    async securityGetWebSealUserInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebSealUserInfoResponseViewModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/securities/webseal-user-info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebSealUserInfoResponseViewModelFromJSON(jsonValue));
    }

    /**
     * A drop in replacement for the Gateway user-info endpoint. This is why it does not return a Result object
     */
    async securityGetWebSealUserInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebSealUserInfoResponseViewModel> {
        const response = await this.securityGetWebSealUserInfoRaw(initOverrides);
        return await response.value();
    }

    /**
     * Log a user out
     */
    async securityLogoutRaw(requestParameters: SecurityLogoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.request === null || requestParameters.request === undefined) {
            throw new runtime.RequiredError('request','Required parameter requestParameters.request was null or undefined when calling securityLogout.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/securities/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LogoutCommandToJSON(requestParameters.request),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Log a user out
     */
    async securityLogout(requestParameters: SecurityLogoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.securityLogoutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * An endpoint to retrieve the users access token. This is meant to be toggled off for production. DEBUG PURPOSES ONLY.
     */
    async securityRetrieveTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/securities/retrieve-token`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfBooleanFromJSON(jsonValue));
    }

    /**
     * An endpoint to retrieve the users access token. This is meant to be toggled off for production. DEBUG PURPOSES ONLY.
     */
    async securityRetrieveToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfBoolean> {
        const response = await this.securityRetrieveTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     * Confirm if the website lock password is correct
     */
    async securityUnlockSiteRaw(requestParameters: SecurityUnlockSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfBoolean>> {
        if (requestParameters.query === null || requestParameters.query === undefined) {
            throw new runtime.RequiredError('query','Required parameter requestParameters.query was null or undefined when calling securityUnlockSite.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/securities/unlock-site`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PasswordProtectionQueryToJSON(requestParameters.query),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfBooleanFromJSON(jsonValue));
    }

    /**
     * Confirm if the website lock password is correct
     */
    async securityUnlockSite(requestParameters: SecurityUnlockSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfBoolean> {
        const response = await this.securityUnlockSiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
